import { useEffect, useState } from 'react'
import { useGetPharmaciesV2 } from 'api/generated/pharmacy-v2/pharmacy-v2'

type Args = {
  patientId: string
  searchInput: string
  patientZip: string
  enabled: boolean
}

export function usePharmacyV2Search({ patientId, searchInput, patientZip, enabled }: Args) {
  const [pharmacySearchZip, setPharmacySearchZip] = useState(patientZip)
  const [searchDebounced, setSearchDebounced] = useState('')

  useEffect(() => {
    if (!enabled) return
    const timer = setTimeout(() => setSearchDebounced(searchInput.trim()), 500)
    return () => clearTimeout(timer)
  }, [searchInput, enabled])

  const hasActiveQuery = searchDebounced.length > 2
  const query = useGetPharmaciesV2(
    { PatientId: patientId, SearchValue: searchDebounced, ZipCode: pharmacySearchZip || patientZip },
    { query: { enabled: Boolean(enabled && hasActiveQuery) } },
  )

  return {
    pharmacies: hasActiveQuery && query.isSuccess ? (query.data ?? []) : [],
    isSearchingDone: hasActiveQuery && query.isSuccess,
    pharmacySearchZip,
    setPharmacySearchZip,
  }
}
